var viewSlotAvailability = {
  accessibilityActions: 16,
  accessibilityActionsWithAccessibilityActionCategory: 18,
  accessibilityChildren: 15,
  accessibilityRepresentation: 15,
  accessibilityShowsLargeContentViewer: 15,
  alert: 15,
  background: 15,
  backgroundPreferenceValuePreferredColorScheme: 16,
  confirmationDialog: 15,
  containerBackground: 17,
  contentToolbar: 18.4,
  contextMenu: 13,
  dismissalConfirmationDialog: 27,
  documentBrowserContextMenu: 18.1,
  fullScreenCover: 14,
  inspector: 17,
  listRowBackground: 13,
  mapControls: 17,
  mask: 15,
  navigationBarItemsWithLeading: 13,
  navigationBarItemsWithTrailing: 13,
  navigationDestination: 16,
  overlay: 15,
  overlayPreferenceValuePreferredColorScheme: 16,
  popover: 13,
  presentationBackground: 16.4,
  safeAreaBarWithHorizontalEdge: 26,
  safeAreaBarWithVerticalEdge: 26,
  safeAreaInsetWithHorizontalEdge: 15,
  safeAreaInsetWithVerticalEdge: 15,
  sceneAccessory: 27,
  searchScopesWithBindingString: 16,
  searchScopesWithBindingStringAndSearchScopeActivation: 16.4,
  searchSuggestions: 16,
  sectionActions: 18,
  sheet: 13,
  subscriptionStoreControlIcon: 17,
  subscriptionStorePolicyDestination: 17,
  swipeActions: 15,
  tabItem: 13,
  tabViewBottomAccessory: 26,
  tabViewBottomAccessoryWithBool: 26.1,
  tabViewSidebarBottomBar: 18,
  tabViewSidebarFooter: 18,
  tabViewSidebarHeader: 18,
  toolbar: 14,
  toolbarOverflowMenu: 27,
  toolbarTitleMenu: 16
};
var viewSlotArguments = {
  accessibilityActions: [],
  accessibilityActionsWithAccessibilityActionCategory: [
    {
      field: "category",
      kind: "enum",
      cases: {
        default: 18,
        edit: 18
      }
    }
  ],
  accessibilityChildren: [],
  accessibilityRepresentation: [],
  accessibilityShowsLargeContentViewer: [],
  alert: [
    {
      field: "title",
      kind: "string"
    },
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  background: [],
  backgroundPreferenceValuePreferredColorScheme: [],
  confirmationDialog: [
    {
      field: "title",
      kind: "string"
    },
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  containerBackground: [
    {
      field: "container",
      kind: "enum",
      cases: {
        navigation: 18,
        navigationSplitView: 18,
        subscriptionStore: 17,
        subscriptionStoreHeader: 17,
        subscriptionStoreFullHeight: 17,
        widget: 17
      }
    }
  ],
  contentToolbar: [
    {
      field: "placement",
      kind: "enum",
      cases: {
        tabViewSidebar: 18.4
      }
    }
  ],
  contextMenu: [],
  dismissalConfirmationDialog: [
    {
      field: "title",
      kind: "string"
    },
    {
      field: "shouldPresent",
      kind: "boolean"
    }
  ],
  documentBrowserContextMenu: [],
  fullScreenCover: [
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  inspector: [
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  listRowBackground: [],
  mapControls: [],
  mask: [],
  navigationBarItemsWithLeading: [],
  navigationBarItemsWithTrailing: [],
  navigationDestination: [
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  overlay: [],
  overlayPreferenceValuePreferredColorScheme: [],
  popover: [
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  presentationBackground: [],
  safeAreaBarWithHorizontalEdge: [
    {
      field: "edge",
      kind: "enum",
      cases: {
        leading: 15,
        trailing: 15
      }
    }
  ],
  safeAreaBarWithVerticalEdge: [
    {
      field: "edge",
      kind: "enum",
      cases: {
        top: 15,
        bottom: 15
      }
    }
  ],
  safeAreaInsetWithHorizontalEdge: [
    {
      field: "edge",
      kind: "enum",
      cases: {
        leading: 15,
        trailing: 15
      }
    }
  ],
  safeAreaInsetWithVerticalEdge: [
    {
      field: "edge",
      kind: "enum",
      cases: {
        top: 15,
        bottom: 15
      }
    }
  ],
  sceneAccessory: [],
  searchScopesWithBindingString: [
    {
      field: "scope",
      kind: "bindingString"
    }
  ],
  searchScopesWithBindingStringAndSearchScopeActivation: [
    {
      field: "scope",
      kind: "bindingString"
    },
    {
      field: "activation",
      kind: "enum",
      cases: {
        automatic: 16.4,
        onTextEntry: 16.4,
        onSearchPresentation: 16.4
      }
    }
  ],
  searchSuggestions: [],
  sectionActions: [],
  sheet: [
    {
      field: "isPresented",
      kind: "bindingBoolean"
    }
  ],
  subscriptionStoreControlIcon: [],
  subscriptionStorePolicyDestination: [
    {
      field: "button",
      kind: "enum",
      cases: {
        termsOfService: 17,
        privacyPolicy: 17
      }
    }
  ],
  swipeActions: [],
  tabItem: [],
  tabViewBottomAccessory: [],
  tabViewBottomAccessoryWithBool: [
    {
      field: "isEnabled",
      kind: "boolean"
    }
  ],
  tabViewSidebarBottomBar: [],
  tabViewSidebarFooter: [],
  tabViewSidebarHeader: [],
  toolbar: [],
  toolbarOverflowMenu: [],
  toolbarTitleMenu: []
};
var viewSlotEvents = {
  backgroundPreferenceValuePreferredColorScheme: {
    kind: "optional",
    value: {
      kind: "enum",
      cases: [
        "light",
        "dark"
      ],
      open: true
    }
  },
  overlayPreferenceValuePreferredColorScheme: {
    kind: "optional",
    value: {
      kind: "enum",
      cases: [
        "light",
        "dark"
      ],
      open: true
    }
  }
};
var tabViewSlotAvailability = {
  tabViewBottomAccessory: 26,
  tabViewSidebarBottomBar: 18,
  tabViewSidebarFooter: 18,
  tabViewSidebarHeader: 18
};
export {
  tabViewSlotAvailability,
  viewSlotArguments,
  viewSlotAvailability,
  viewSlotEvents
};
//# sourceMappingURL=viewSlots.js.map
